'use client';

import { Button } from '@/components/ui/button';
import { UsersIcon, SlidersHorizontal } from 'lucide-react';

interface EmptyStateProps {
  hasTeams: boolean;
  resetFilters: () => void;
}

export function EmptyState({ hasTeams, resetFilters }: EmptyStateProps) {
  if (hasTeams) {
    return (
      <div className="py-8 text-center">
        <SlidersHorizontal className="mx-auto mb-4 h-12 w-12 text-gray-300" />
        <h3 className="text-lg font-medium">No hay resultados</h3>
        <p className="text-gray-500">
          No se encontraron equipos que coincidan con los filtros aplicados.
        </p>
        <Button
          variant="outline"
          size="sm"
          className="mt-4"
          onClick={resetFilters}
        >
          Limpiar filtros
        </Button>
      </div>
    );
  }

  return (
    <div className="py-8 text-center">
      <UsersIcon className="mx-auto mb-4 h-12 w-12 text-gray-300" />
      <h3 className="text-lg font-medium">No hay participantes registrados</h3>
      <p className="text-gray-500">
        Aún no hay equipos inscritos en este torneo.
      </p>
    </div>
  );
}
